/**
 * Determines whether an element has a slot. If name is specified, the function will look for a corresponding named slot,
 * otherwise it will look for a "default" slot (e.g. a non-empty text node or an element with no slot attribute).
 *
 * Todo: detecting a default slot might be tricky in some cases. Re-evaluate!
 * @param el The element
 * @param name The name of the slot
 */
export function hasSlot(el, name) {
    // Look for a named slot
    if (name !== undefined && name.length > 0) {
        return el.querySelector(`[slot="${name}"]`) !== null;
    }
    // Look for a default slot
    return Array.from(el.childNodes).some((node) => {
        if (node.nodeType === node.TEXT_NODE &&
            /* eslint-disable-next-line */
            node.textContent.trim() !== "") {
            return true;
        }
        if (node.nodeType === node.ELEMENT_NODE) {
            const el = node;
            if (!el.hasAttribute("slot")) {
                return true;
            }
        }
        return false;
    });
}
//# sourceMappingURL=hasSlot.js.map
